export function TimeSpan2Dias(TimeSpan) {
  if (!TimeSpan || TimeSpan == "") return 0;
  var Dias = TimeSpan.split(".");
  var Horas = "";
  var NoDias = 0;
  if (Dias.length > 1) {
    return parseInt(Dias[0]);
  }
  return 0;
}
export function TimeSpan2Hora(TimeSpan) {
  if (!TimeSpan || TimeSpan == "") return "";
//console.debug(TimeSpan);
  var Dias = TimeSpan.split(".");
  var Horas = "";
  var NoDias = 0;
  if (Dias.length > 1) {
    NoDias = parseInt(Dias[0]);
    Horas = Dias[1];
  } else Horas = Dias[0];
  var Partes = Horas.split(":");
  var NoHoras = parseInt(Partes[0]);
  var NoMinutos = parseInt(Partes[1]);
  var NoSegundos = parseInt(Partes[2]);

  var R =
    NoHoras >= 12
      ? `${
          NoHoras == 12 ? NoHoras : NoHoras % 12
        }:${NoMinutos.toString().padStart(2, "0")} pm`
      : `${NoHoras % 12}:${NoMinutos.toString().padStart(2, "0")} am`;
  return R;
}
/**
 * Convierte un formato hora a timespan
 * @param {*} Dias 1
 * @param {*} Hora Formato 11:48 pm
 * @returns 1.23:48
 */
export function Hora2TimeSpan(Dias, Hora) {
  if (Hora == null || Hora.length < 6) return "00:00:00";
 // console.debug(Hora);
  var PartesA = Hora.split(" ");
  var Partes = PartesA[0].split(":");
  var AM = PartesA[1][0];
  var NoHoras = parseInt(Partes[0]);
  var NoMinutos = parseInt(Partes[1]);
  if (AM == "p") {
    NoHoras += 12;
    if (NoHoras >= 24) NoHoras -= 12;
  }
  if (AM == "a") if (NoHoras >= 12) NoHoras -= 12;

  var TS = `${NoHoras.toString().padStart(
    2,
    "0"
  )}:${NoMinutos.toString().padStart(2, "0")}:00`;

  if (Dias > 0) TS = `${Dias}.${TS}`;
  //console.debug(TS);
  return TS;
}
export function Fecha2TimeSpan(Fecha) {
  var Diferencia = Fecha - Date.parse("01/01/1970");
  var SoloMLSeg = Diferencia % 1000;
  Diferencia = Math.trunc(Diferencia / 1000);
  var SoloSeg = Diferencia % 60;
  Diferencia = Math.trunc(Diferencia / 60);
  var SoloMin = Diferencia % 60;
  Diferencia = Math.trunc(Diferencia / 60);
  var SoloHoras = Diferencia % 24;
  Diferencia = Math.trunc(Diferencia / 24);
  var SoloDias = Diferencia;
  var R = "";
  if (SoloDias > 0) R = `${SoloDias}.`;
  R += `${SoloHoras.toString().padStart(2, "0")}:${SoloMin.toString().padStart(
    2,
    "0"
  )}:${SoloSeg.toString().padStart(2, "0")}`;
  return R;
}
export function Hora2Fecha(Dias, Hora) {
  var Dia = Dias + 1;
  // console.debug(Date.parse("0001/01/01"));
  //Mes, Dia, Año
  var Texto = `01/${Dia}/1970 ${Hora}`;
  //console.debug(Texto);
  var R = Date.parse(Texto);
  console.debug(R);
  return R;
}

export function TimeSpan2Segundos(TimeSpan) {
  if (!TimeSpan || TimeSpan == "") return 0;
  /*
  var Dias = TimeSpan.split(".");
  var Horas = "";
  var NoDias = 0;
  if (Dias.length > 1) {
    NoDias = parseInt(Dias[0]);
    Horas = Dias[1];
  }
  else
    Horas = Dias[0];
    */
  var Signo = 1;
  if (TimeSpan[0] == "-") {
    Signo = -1;
    TimeSpan = TimeSpan.substring(1);
  }

  var Partes = TimeSpan.split(":");
  var PHoras = Partes[0].split(".");

  var NoHoras =
    PHoras.length > 1
      ? parseInt(PHoras[0]) * 24 + parseInt(PHoras[1])
      : parseInt(Partes[0]);
  var NoMinutos = parseInt(Partes[1]);
  var NoSegundos = 0;
  if (Partes[2]) {
    var PSegundos = Partes[2].split(".");
    NoSegundos = parseInt(PSegundos[0]);
  }

  var R = (NoHoras * 60 + NoMinutos) * 60 + NoSegundos;
  return R * Signo;
}
export function TimeSpan2Minutos(TimeSpan) {
  var Segundos = TimeSpan2Segundos(TimeSpan);
  if (Segundos == "") return Segundos;
  return Math.trunc(Segundos / 60);
}
export function SegundosAgregaDias(Segundos, Dias) {
  return Segundos + Dias * 24 * 60 * 60;
}
export function SegundosAgregaHoras(Segundos, Horas) {
  return Segundos + Horas * 60 * 60;
}
//Si NoResumir entonces no dividirá las horas entre 24
export function Segundos2TimeSpan(Segundos, NoResumir) {
  var Diferencia = Math.trunc(Segundos);
  var SoloSeg = Diferencia % 60;
  Diferencia = Math.trunc(Diferencia / 60);
  var SoloMin = Diferencia % 60;
  Diferencia = Math.trunc(Diferencia / 60);
  var R = "";
  if (NoResumir == null || !NoResumir) {
    var SoloHoras = Diferencia % 24;
    Diferencia = Math.trunc(Diferencia / 24);
    var SoloDias = Diferencia;

    if (SoloDias > 0) R = `${SoloDias}.`;
    R += `${SoloHoras.toString().padStart(
      2,
      "0"
    )}:${SoloMin.toString().padStart(2, "0")}:${SoloSeg.toString().padStart(
      2,
      "0"
    )}`;
  } else {
    R = `${Diferencia.toString()}:${SoloMin.toString().padStart(
      2,
      "0"
    )}:${SoloSeg.toString().padStart(2, "0")}`;
  }

  return R;
}

export function Segundos2HorasMinutos(Segundos) {
  var Diferencia = Math.trunc(Segundos);
  var SoloSeg = Diferencia % 60;
  Diferencia = Math.trunc(Diferencia / 60);
  var SoloMin = Diferencia % 60;
  Diferencia = Math.trunc(Diferencia / 60);
  return `${Diferencia.toString()}:${SoloMin.toString().padStart(2, "0")}`;
}

export function Minutos2TimeSpan(Minutos) {
  return Segundos2TimeSpan(Minutos * 60);
}
///Convierte minutos al formato h:MM si absoluto es verdadero no mostrará el signo -
export function Minutos2sHoras(Minutos, Absoluto) {
  var TotalMinutos = Minutos;
  var Horas = Math.trunc(TotalMinutos / 60);
  var Minutos = Math.abs(TotalMinutos % 60);
  if (Absoluto) Horas = Math.abs(Horas);
  var SMinutos = Minutos < 10 ? `0${Minutos}` : `${Minutos}`;
  return `${Horas}:${SMinutos}`;
}
export function TimeSpan2sHoras(TimeSpan, Absoluto) {
  var minutos = TimeSpan2Minutos(TimeSpan);

  return Minutos2sHoras(minutos, Absoluto);
}
